import { getClassLevel } from './classIdentity.mjs';

export const LANGUAGE_OPTIONS = Object.freeze([
  'Common', 'Common Sign Language', 'Draconic', 'Dwarvish', 'Elvish', 'Giant',
  'Gnomish', 'Goblin', 'Halfling', 'Orc', 'Abyssal', 'Celestial', 'Deep Speech',
  'Druidic', 'Infernal', 'Primordial', 'Sylvan', 'Undercommon',
]);

export const getCharacterLanguages = (character = {}, { includeRogueChoice = true, includeRangerChoice = true } = {}) => {
  const values = [character.languages, character.race?.languages, character.background?.languages,
    ...(character.feat || []).map(feat => feat?.languages)].flatMap(value => Array.isArray(value) ? value : []);
  if (getClassLevel(character, 'rogue') >= 1) {
    values.push('Thieves’ Cant');
    if (includeRogueChoice && character.classState?.rogue?.bonusLanguage) values.push(character.classState.rogue.bonusLanguage);
  }
  if (getClassLevel(character, 'druid') >= 1) values.push('Druidic');
  // 2024 Ranger Deft Explorer (level 2): two languages of the player's choice.
  if (includeRangerChoice && getClassLevel(character, 'ranger') >= 2 && Array.isArray(character.classState?.ranger?.deftExplorerLanguages)) {
    values.push(...character.classState.ranger.deftExplorerLanguages);
  }
  const seen = new Set();
  return values.filter(value => {
    if (typeof value !== 'string' || !value.trim() || /choice/i.test(value)) return false;
    const key = value.trim().toLowerCase().replace(/[’']/g, '');
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  }).map(value => value.trim());
};
